module.exports = __webpack_public_path__ + "static/media/default-avatar.086ff580.png";